var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useLazyQuery } from '@apollo/client/react';
import { GetDocxConverterTokenDocument } from './query.gql';
import { useGetTokenWrapper } from '../useGetTokenWrapper';
export const useGetDocxConverterToken = (options) => {
    const { documentId, skip } = options;
    const [getTokenLazy] = useLazyQuery(GetDocxConverterTokenDocument, {
        fetchPolicy: 'network-only',
    });
    if (skip) {
        return undefined;
    }
    const getTokenWrapper = useGetTokenWrapper();
    const getToken = () => __awaiter(void 0, void 0, void 0, function* () {
        const { data, error } = yield getTokenLazy({
            variables: { documentId },
        });
        const { token } = (data === null || data === void 0 ? void 0 : data.docxConverterToken) || {};
        return { token, error };
    });
    const getDocxConverterToken = () => __awaiter(void 0, void 0, void 0, function* () { return getTokenWrapper(getToken); });
    return getDocxConverterToken;
};
